import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import PropTypes from 'prop-types';

/**
 * UnsavedChangesDialog - Generic confirmation dialog for unsaved changes
 * @param {boolean} isOpen - Dialog open state
 * @param {function} okCallBack - Optional callback for OK/Save button
 * @param {function} closeCallBack - Optional callback for Close/Discard button
 * @param {function} cancelCallBack - Optional callback for Cancel button
 * @param {string} messageConfirm - Message to display in dialog
 * @param {string} okBtnText - Text for OK button (if okCallBack provided)
 * @param {string} closeBtnText - Text for Close button (if closeCallBack provided)
 * @param {string} cancelBtnText - Text for Cancel button (if cancelCallBack provided)
 */
function UnsavedChangesDialog({
    isOpen,
    okCallBack,
    closeCallBack,
    cancelCallBack,
    messageConfirm,
    okBtnText,
    closeBtnText,
    cancelBtnText,
}) {
    if (!isOpen) return null;
    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">{messageConfirm}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                {/* OK Button - typically for Save action */}
                {okCallBack && okBtnText && (
                    <Button
                        onClick={okCallBack}
                        variant="contained"
                        className="btn-hg32 MuiButton-containedPrimary"
                    >
                        {okBtnText}
                    </Button>
                )}

                {/* Close Button - typically for Discard/Proceed action */}
                {closeCallBack && closeBtnText && (
                    <Button
                        onClick={closeCallBack}
                        variant="contained"
                        className="btn-hg32 btn-handle-delete-user-agree"
                    >
                        {closeBtnText}
                    </Button>
                )}

                {/* Cancel Button - typically for Cancel/Keep editing action */}
                {cancelCallBack && cancelBtnText && (
                    <Button
                        onClick={cancelCallBack}
                        variant="contained"
                        className="btn-light btn-hg32"
                    >
                        {cancelBtnText}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}

UnsavedChangesDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    okCallBack: PropTypes.func,
    closeCallBack: PropTypes.func,
    cancelCallBack: PropTypes.func,
    messageConfirm: PropTypes.string,
    okBtnText: PropTypes.string,
    closeBtnText: PropTypes.string,
    cancelBtnText: PropTypes.string,
};

export default UnsavedChangesDialog;
